import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchTrialCompletionPreview = async (trialId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${__API_URL__}/api/photos/trials/${trialId}/completion-preview/`,
    {
      headers: { Authorization: `Token ${token}` },
    }
  );
  return response.data;
};

const useGetTrialCompletionPreview = ({ trialId }) => {
  return useQuery({
    queryKey: ["trial-completion-preview", trialId],
    queryFn: () => fetchTrialCompletionPreview(trialId),
    enabled: false,
  });
};

export default useGetTrialCompletionPreview;
